import { useGetFinalGradesQuery } from "../finalGradeApiSlice"
import FinalGrade from "./FinalGrade"
import useAuth from "../../../hooks/useAuth"
import PulseLoader from 'react-spinners/PulseLoader'
import { faAdd } from "@fortawesome/free-solid-svg-icons"
import { Link, useParams } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import FinalGradeDetail from "./FinalGradeDetails"
import { useState } from "react"
import GroupGradeUpdateForm from "./GroupGradeUpdateForm"
const FinalGradesList = ({q}) => {
    const {groupId} = useParams()
    const {  isTeacher, isAdmin } = useAuth()
    const {
        data,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetFinalGradesQuery('finalGradesList', {
        // pollingInterval: 15000,
        // refetchOnFocus: true,
        refetchOnMountOrArgChange: false
    })
    const [showModal, setShowModal] = useState(false)
    const [currentFinalGrade, setCurrentFinalGrade] = useState(null)
    const [showUpdateModal, setShowUpdateModal] = useState(false)
    const [currentGroupGrade, setCurrentGroupGrade] = useState(null)


    let content

    if (isLoading) content = <PulseLoader color={"#FFF"} />

    if (isError) {
        content = <p className="errmsg">{error?.data?.message}</p>
    }

    if (isSuccess ) {
        const {finalGrades,groupGrades} =data

        const filteredFinalGrade = (groupId==="0" && !q)? [...finalGrades] : finalGrades.filter(finalGrade =>{
          return   (groupId ==="0" || finalGrade.group === groupId) &&
            (!q || (
                (finalGrade.username.toLowerCase().indexOf(q) > -1) ||
                (finalGrade.fullname.toLowerCase().indexOf(q) > -1) ||
                (finalGrade.finalGradeBase.groupName.toLowerCase().indexOf(q) > -1) ||
                (finalGrade.finalGradeBase.courseName.toLowerCase().indexOf(q) > -1) ||
                (finalGrade.finalGradeBase.year.toLowerCase().indexOf(q) > -1) 
            ) )
        }) 
        const tableContent = filteredFinalGrade.map(finalGrade =>{
            const groupGrade = groupGrades.find(gg=>gg.user.toString()=== finalGrade.user.toString() && gg.group.toString()=== finalGrade.group.toString()  )
            return <FinalGrade  key={finalGrade._id} groupGrade={groupGrade} setShowModal={setShowModal} setCurrentFinalGrade={setCurrentFinalGrade} finalGrade={finalGrade} setCurrentGroupGrade={setCurrentGroupGrade}  setShowUpdateModal={setShowUpdateModal} />
        } )

        content = (
            <>
            <table className={`table table--finalGrades ${(isAdmin || isTeacher)&& "table--finalGrades--admin"} `}>
                <thead className="table__thead">
                    <tr>
                        <th scope="col" className="table__th finalGrade__title">username </th>
                        <th scope="col" className="table__th finalGrade__title">שם  </th>
                        <th scope="col" className="table__th finalGrade__title">שם הקורס</th>
                        <th scope="col" className="table__th finalGrade__body">מחצית</th>
                        <th scope="col" className="table__th finalGrade__dates"> שנה</th>
                        <th scope="col" className="table__th finalGrade_student finalGrade__done"> ציון משוקלל</th>
                        <th scope="col" className="table__th finalGrade_student finalGrade__done"> סופי לגליון</th>
                        <th scope="col" className="table__th finalGrade_student finalGrade__done"> חישוב</th>
                        <th scope="col" className="table__th finalGrade__edit"> <span className=" no-print"> #</span></th>
                    </tr>
                </thead>
                <tbody>
                    {tableContent}
                </tbody>
            </table>

            <FinalGradeDetail showModal={showModal} setShowModal={setShowModal} currentFinalGrade={currentFinalGrade} />
            <GroupGradeUpdateForm showUpdateModal={showUpdateModal} setShowUpdateModal={setShowUpdateModal} currentGroupGrade={currentGroupGrade} />
            </>
        )
    }

    return content
}
export default FinalGradesList